"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Typography_1 = __importDefault(require("../Typography"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var Button_1 = __importDefault(require("../Button"));
var CultureCloudGradientLogo_1 = __importDefault(require("../Header/CultureCloudGradientLogo"));
var styles_1 = require("./styles");
var Error = function (_a) {
    var errorCode = _a.errorCode, _b = _a.homepageUrl, homepageUrl = _b === void 0 ? '/' : _b, recognizeUrl = _a.recognizeUrl, routerBack = _a.routerBack, _c = _a.recognitionPermission, recognitionPermission = _c === void 0 ? false : _c;
    var t = (0, react_i18next_1.useTranslation)().t;
    var breakAfterComma = function (text) {
        var commaIndex = text.indexOf(',');
        if (commaIndex === -1) {
            return text;
        }
        var firstPart = text.slice(0, commaIndex + 1);
        var secondPart = text.slice(commaIndex + 1);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            firstPart,
            react_1.default.createElement("br", { "aria-hidden": true }),
            secondPart));
    };
    var renderText = function () {
        var sorry = breakAfterComma(t('prism-header:error-has-occured', 'We’re sorry, an error has occurred.'));
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(styles_1.SorryText, { variant: "h1", fontSize: "56px", lineHeight: "64px" }, sorry),
            react_1.default.createElement(styles_1.MarginBottom, null,
                react_1.default.createElement(Typography_1.default, null, t('prism-header:service-unavailable', "Service is temporarily unavailable. We're incredibly sorry for the inconvenience. Please try again at a later time.")),
                recognitionPermission && (react_1.default.createElement(Typography_1.default, { "data-testid": "error:text:recognize someone" }, t('prism-header:send-some-recognition', 'While you wait, take a second to send some recognition!'))),
                errorCode && (react_1.default.createElement(styles_1.ErrorCodeContainer, { "data-testid": "error:text:error code" },
                    t('prism-header:code', 'Code:'),
                    " ",
                    errorCode)))));
    };
    var renderButtons = function () {
        return (react_1.default.createElement(styles_1.MarginBottom, null,
            recognitionPermission && recognizeUrl && (react_1.default.createElement(styles_1.StyledButton, { "data-testid": "error:button:recognize someone", href: recognizeUrl }, t('prism-header:recognize-someone', 'Recognize someone'))),
            routerBack !== undefined && (react_1.default.createElement(styles_1.MiddleButton, { color: "secondary", onClick: routerBack, "data-testid": "error:button:go back" }, t('prism-header:go-back', 'Go back'))),
            homepageUrl && (react_1.default.createElement(Button_1.default, { variant: "text", "data-testid": "error:button:return to homepage", href: homepageUrl }, t('prism-header:return-to-homepage', 'Return to homepage')))));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(CultureCloudGradientLogo_1.default, { "data-testid": "culturecloud-logo", "aria-label": "Culture Cloud Logo" }),
        renderText(),
        renderButtons()));
};
exports.default = Error;
//# sourceMappingURL=index.js.map